__turbopack_context__.v({
  "filterPanel": "ArSpaceFilterBar-module-scss-module__wVwVCa__filterPanel",
  "filterPanelOpen": "ArSpaceFilterBar-module-scss-module__wVwVCa__filterPanelOpen",
  "filterPanelScrollDown": "ArSpaceFilterBar-module-scss-module__wVwVCa__filterPanelScrollDown",
  "filterPanelScrollUp": "ArSpaceFilterBar-module-scss-module__wVwVCa__filterPanelScrollUp",
});
